import React, { useMemo } from 'react';
import { CurrencySelector } from '@shared/components/CurrencySelector';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useStationeryCurrencies } from '@shared/utils/currency/useStationeryCurrencies';
import { useStationeryCurrency } from '@shared/utils/currency/useStationeryCurrency';

/**
 * PrintCurrencySelector component is a wrapper around the CurrencySelector component for print.
 *
 * Offers every currency card_service sells in. Shows an inert trigger until that list loads: the picker
 * resets any currency missing from its list to USD and reloads, so opening it against the site-wide default
 * list would bounce a buyer who picked e.g. PLN. Shows the resolved stationery currency, which can differ from
 * the geo locale's (e.g. PLN for a `pl-PL` visitor the locale table maps to USD), so it matches the prices.
 * @returns CurrencySelector component for print
 */
export const PrintCurrencySelector = () => {
  const [isCurrencySelectorEnabled] = useIsFeatureEnabled('printLocalCurrency');
  const currencies = useStationeryCurrencies();
  const currency = useStationeryCurrency();
  const options = useMemo(() => currencies?.map(({ currencyCode, name }) => ({ code: currencyCode, name })), [currencies]);

  return (
    <CurrencySelector
      isEnabled={isCurrencySelectorEnabled}
      isLoading={!options}
      supportedCurrencies={options}
      currency={currency}
      dropdownPositionStyle={{ right: 0 }}
    />
  );
};
